import React from "react";
import { connect } from "react-redux";
import { View, ViewTitle } from "../../shared/styled/view";
import Loader from "../../shared/icons/tat/loader";
import FilterBarCompact from "../../shared/component/filter/filter-bar-compact";
import OptionSelectorSwitch from "../../shared/controls/option-selector-switch";
import { getEntityItems, readCatalog, readEntities } from "../../redux/api";
import { getCurrentCommandTabSelected, getTimeZone, setCurrentCommandTabSelected, showSimpleFlashNotification } from "../../shared/utils";
import { TripTrTableView } from "./tables/trip-tr-table-view";
import PaginatorControlled from "../../shared/controls/paginator-controlled";
import { cancelMultipleRequests, partialEntity, readEntity } from "../../redux/api/actions";
import CatalogSelectionFooter from "../../shared/component/catalog-selection-footer";
import BaseDialog from "../../shared/dialog/base-dialog";
import Checkbox from "../../shared/controls/checkbox";
import GenericDialog from "../../shared/dialog/generic-modal";
import AssembleShipmentAssignDialog from "../assemble-shipment/assemble-shipment-assign-dialog";
import * as Utils from "../assemble-shipment/utils";
import styled from "styled-components";

const TRIPTYPES = [
  { description: "FTL", value: 1 },
  { description: "LTL", value: 2 },
]

class TripsTrControlView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      emails: [],
      buttonFilterName: "Aplicar",
      tripType: 1,
      searchStr: '',
      vehiclesToShow: [],
      offset: 1,
      limit: 50,
      isAllTripsSelected: false,
      seed: Math.random(),

      filter: {
        baseTags: [],
        vehicle: [],
        transportClass: [],
        tripStatus: [],
        orderStatus: [],
        fleetProviders: [],
        fromFacilities: [],
        toFacilities: [],
        fromToFacilities: [],
        appointment: [],
        appointmentType: []
      },
      tripsSelected: [],
      confirmReservation: null,
      errorMessage: null,
      hasAutoStart: true,
      showAssignDialog: false,
      selectedAssembly: 0,
      assign: null
    };
  }

  componentDidMount() {

    if (this.props.location.search.includes('facilities') || this.props.location.search.includes('fleet_provider')) {
      const query = new URLSearchParams(this.props.location.search);

      let current_tab = getCurrentCommandTabSelected();

      if (current_tab && current_tab.third_tab) {
        this.state.tripType = current_tab.third_tab;
      }

      let query_facilities = query.get('facilities') || '';
      let query_fleet_providers = query.get('fleet_provider') || '';

      this.state.filter.fromToFacilities = query_facilities !== '' ? `${query_facilities}`.split(',').map(item => parseInt(item)) : [];
      this.state.filter.fleetProviders = query_fleet_providers !== '' ? `${query_fleet_providers}`.split(',').map(item => parseInt(item)) : [];

      this.setState({}, () => {
        this.loadFilter();
      });

    } else {

      let current_tab = getCurrentCommandTabSelected();

      if (current_tab && current_tab.third_tab) {
        this.state.tripType = current_tab.third_tab;
      }

      this.loadFilter();
    }

    this.props.loadFilters({
      company_id: this.props.companyId,
    });

    this.props.loadCompanyTags({
      company_id: this.props.companyId
    });

    this.props.loadTransportClass({
      company_id: this.props.companyId,
    });

    this.props.loadCompanyProviders({
      company_id: this.props.companyId,
      view: "booking",
    });

  }

  loadFilter = () => {
    this.props.loadTripFilterConfig({
          company_id: this.props.companyId
    }, {
      onSuccess: (response) => {
        this.state.tripFilter = response.trip_tr_filter || null;
        this.loadVehicles();
      },
      onError: () => {
        this.loadVehicles();
      }
    });
  }

  loadVehicles = () => {
    this.props.listVehicles({company_id: this.props.companyId},
      {
        onSuccess: (vehiclesData) => {
          let newIndex = 9999999999;
          let vehiclesToShow = [];

          for (let i = 0; i < vehiclesData.length; i++) {

            let dataEconomic = vehiclesData[i];
            let vehicles = (dataEconomic.economic_numbers || []).map( (f) => ({
              id: f.id || 0,
              description: f.economic_number || '',
              isDisabled: !f.is_assembled || false,
              disableMessage: 'Camion sin ensamble'
            }));

            if (vehicles.length > 0) {
              vehiclesToShow.push({
                id: newIndex,
                description: `${dataEconomic.title || ''}` === 'N/A' ? 'Sin base' : `${dataEconomic.title || ''}`,
                items: vehicles
              });
              newIndex = newIndex - 1;
            }

          }

          this.setState({
            vehiclesToShow
          });

          this.loadItems();
        },
        onError: (error) => {
          this.loadItems();
        }
      }
    );
  }

  handleTabChange = (e) => {
    const { name, value } = e.target;
    setCurrentCommandTabSelected(null, null, value);

    this.setState({ [name]: value, offset: 1}, () => { this.loadItems() });
  };

  loadItems = () => {
    if (this.state.getOrdersCalled) {
      this.props.cancelMultipleRequests();
    }

    this.setState({ getOrdersCalled: true });

    let codes = this.state.emails.map( item => item.email);
    let params = {}

    if (codes.length > 0) {
      params = {
        company_id: this.props.companyId,
        transportType: this.state.tripType,
        baseTags: '',
        vehicle: '',
        transportClass: '',
        tripStatus: '',
        orderStatus: '',
        fleetProviders: '',
        fromFacilities: '',
        toFacilities: '',
        fromToFacilities: '',
        appointmentType: '',
        appointment: '',
        limit: this.state.limit,
        offset: this.state.offset,
        isMultipleCancels: true,
        tripCodes: codes,
        timezone: getTimeZone()
      };
    } else {
      params = {
        company_id: this.props.companyId,
        transportType: this.state.tripType,
        baseTags: this.state.filter.baseTags,
        vehicle: this.state.filter.vehicle,
        transportClass: this.state.filter.transportClass,
        tripStatus: this.state.filter.tripStatus,
        orderStatus: this.state.filter.orderStatus,
        fleetProviders: this.state.filter.fleetProviders,
        fromFacilities: this.state.filter.fromFacilities,
        toFacilities: this.state.filter.toFacilities,
        fromToFacilities: this.state.filter.fromToFacilities,
        appointmentType: this.state.filter.appointmentType,
        appointment: this.state.filter.appointment[0] ? "".concat(this.state.filter.appointment[0].toISOString(), ",", this.state.filter.appointment[1] ? this.state.filter.appointment[1].toISOString() : this.state.filter.appointment[0].toISOString()) : "",
        limit: this.state.limit,
        offset: this.state.offset,
        isMultipleCancels: true,
        tripCodes: '',
        timezone: getTimeZone()
      };
    }


    this.props.loadTrips(params, {
      onSuccess: () => {
        this.setState({seed: Math.random()});
      }
    })

  }

  filterContent = () => {

    let statusCondensed = this.props.tripStatuses.filter(s => !s.description.toLowerCase().includes("reservación confirmada"));
    let dateTypes = [
      {
        id: "1",
        description: "Carga"
      },
      {
        id: "2",
        description: "Descarga"
      }
    ];

    return [
      {
        title: "Base",
        items: this.props.companyTags.filter((f) => f.type === 3),
        name: "baseTags",
        listType: 1,
      },
      {
        title: "Vehículo",
        items: this.state.vehiclesToShow,
        name: "vehicle",
        listType: 5,
      },
      {
        title: "Clase",
        items: this.props.transportClass,
        name: "transportClass",
        listType: 5,
      },
      {
        title: "Estatus Viaje",
        items: statusCondensed,
        name: "tripStatus",
        listType: 5,
      },
      {
        title: "Estatus Orden",
        items: this.props.orderStatus,
        name: "orderStatus",
        listType: 5,
      },
      {
        title: "Cliente",
        items: this.props.companyProviders,
        name: "fleetProviders",
        listType: 5,
      },
      {
        title: "Origen",
        items:  this.props.filterInfo.map(fI => ({
          id: fI.id,
          description: fI.orbi_id || fI.corporation_name,
          items: fI.facilities.map(f => ({
            id: f.id,
            description: f.name
          }))
        })),
        name: "fromFacilities",
        listType: 5,
      },
      {
        title: "Destino",
        items:  this.props.filterInfo.map(fI => ({
          id: fI.id,
          description: fI.orbi_id || fI.corporation_name,
          items: fI.facilities.map(f => ({
            id: f.id,
            description: f.name
          }))
        })),
        name: "toFacilities",
        listType: 5,
      },
      {
        title: "Origen/Destino",
        items:  this.props.filterInfo.map(fI => ({
          id: fI.id,
          description: fI.orbi_id || fI.corporation_name,
          items: fI.facilities.map(f => ({
            id: f.id,
            description: f.name
          }))
        })),
        name: "fromToFacilities",
        listType: 5,
      },
      {
        title: "Fecha",
        name: "appointment",
        listType: 7,
        time: true
      },
      {
        title: "Tipo fecha",
        items: dateTypes,
        name: "appointmentType",
        listType: 5,
      }
    ];
  }

  handleEmailInput = (e) => {
    if (e) {
      switch (e.target.name) {
        case "inviteTags":
          let mails = e.target.value
            .map((i) => ({
              email: i.email,
              avatar: "hide",
              avatarType: "",
              userId: null,
            }));
          this.setState({ 
            emails: mails, 
            searchStr: e.target.value.map(e => e.email), 
            offset: 1,
            buttonFilterName: "Aplicar"
          }, this.loadItems);
          break;
        case "deleteTags":
          this.setState({ emails: [].concat(e.target.value), searchStr: e.target.value.map(e => e.email), offset: 1 }, this.loadItems);
          break;
        default:
      }
    }
  };

  getCount = () => {
    return this.props.tripsCount;
  }

  getHeaderInfoSelection = () => { 
    return(
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#afc8ff'
        }}
      >
      </div>
    );
  }

  openDocument = (url) => {
    let array = url.split("/");
    let lastSegment = array.length > 0 ? array[array.length - 1] : ".";

    fetch(url)
      .then(response => response.blob())
      .then(blob => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = lastSegment;
          link.click();
      })
      .catch(console.error);
  };

  handleTripGridChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    switch(name) {
      case 'assign':
        if (this.props.tripBookingAvailabilityLoading) return;
        this.setState({assign: value}, () => {
          this.loadTripBookingAvailability()
        });
        break;
      case 'confirm_reservation':
        if (this.props.isTripBalanceLoading) return;
        this.setState({confirmReservation: value});
        this.acceptTrip(value);
        break;
      case 'trip_selected':
        this.props.history.push(`/company/controls/shipment/orderdetail/${value.trip_id}/`);
        break;
      case 'trips_selected':
        this.setState({tripsSelected: value});
        break;
      case 'open_document':
        this.openDocument(value);
        break;
      default:
        console.log('no action');
    }
  }

  acceptTrip = (trip) => {
    this.props.getTripBalance({
      company_id: this.props.companyId,
      trip_id: trip.trip_id
    },
    {
      onError: (e) => {
        this.setState({
          errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
        })
      },
      onSuccess: () => {
        this.setState({
          currentTrip: trip,
          showConfirmDialog: true
        })
      }
    });
  };

  acceptTripAction = () => {
    this.props.updateTrip(
      {
        company_id: this.props.companyId,
        trip_id: this.state.confirmReservation.trip_id,
        has_automatic_start: this.state.hasAutoStart ? "true" : "false",
        action: "confirm_booking",
      },
      { 
        onSuccess: () => {this.loadItems(); this.setState({showConfirmDialog: false, hasAutoStart: true, currentTrip: undefined, confirmReservation: null})},
        onError: (e) => {
        this.setState({
          errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
        })
      }
      }
    );
  }

  handleAutoStart = e => {
    this.setState({ hasAutoStart: !this.state.hasAutoStart });
  }

  getModalContent = () => {
      return (
        <div className="balance-modal-content">
          <div style={{fontSize: "17px"}}>
            Al confirmar el viaje <b>{this.state.confirmReservation.signature}</b> se cobrarán: <span style={{color: "#3d77f7"}}>{this.props.tripBalance["trip"] && this.props.tripBalance["trip"].credits}</span>
          </div>
          <div className="tripTable">
            <div className="tripTable-header">
              <div>
                Folios
              </div>
              <div>
                Orbibucks
              </div>
            </div>
            <div className="tripTable-body">
              {
                this.props.tripBalance["trip"] &&
                this.props.tripBalance["trip"].orders.map(o => {
                  return (
                    <div className="tripTable-row">
                      <div>{o.code}</div>
                      <div>{o.credits}</div>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div>
            Tu nuevo saldo será: {this.props.tripBalance["trip"] && this.props.tripBalance["trip"].final_balance}
          </div>
          {
            (this.state.currentTrip.assemble &&
            this.state.currentTrip.details.some(d => (
              d.destination?.date || d.origin?.date
            ))) &&
            <div style={{marginTop: "10px"}}>
              <Checkbox
                name="auto"
                onChange={this.handleAutoStart}
                item={{
                  id: 1,
                  description: "Inicio automático",
                  active: this.state.hasAutoStart,
                  style: false
                }}
              />
            </div>
          }
          
        </div>
      )
    }

  loadTripBookingAvailability = () => {
    this.props.loadTrip(
      {
        company_id: this.props.companyId,
        trip_id: this.state.assign.trip_id,
        view: "booking",
      },
      {
        alias: "TripBookingAvailability",
        onSuccess: () => {
          this.setState({
            showAssignDialog: true
          });
        }
      }
    );
  };

  manageAssignModal = (e: any) => {
    const { name, value } = e.target;
    switch (name) {
      case "open":
        this.setState(
          { showAssignDialog: true, currentTrip: value },
          this.loadTripBookingAvailability
        );
        break;
      case "close":
      case "cancel":
        this.setState({ showAssignDialog: false, currentTrip: undefined, selectedAssembly: 0, hasAutoStart: true });
        break;
      case "save":
        // let equipmentList = this.props.tripBookingAvailability
        //   .find(a => a.id.toString() === this.state.selectedAssembly)
        //   .equipments.filter(e => e.type.toLowerCase() !== "dolly");

        // TO-DO: Falta validar los contenedores
        // if(this.state.assign.orders.some(d => d.orderContainers.length < equipmentList.length)){
        //   this.setState({
        //     showAssignDialog: false,
        //     showSelectEquipmentModal: true,
        //   })
        // } else {

          this.setState({isLoading: true});
          this.props.updateTrip(
            {
              company_id: this.props.companyId,
              trip_id: value.tripId,
              assembly: value.assembly,
              has_automatic_start: this.state.hasAutoStart ? "true" : "false",
              action: "set_assembly",
            },
            { 
              onSuccess: () => {
                this.loadItems();
                  // TO-DO: Falta actualizar los contenedores
                  // this.state.assing.orders.forEach(d => {
                  //   d.orderContainers.forEach((c, i) => {
                  //     this.props.updateContainer({
                  //       company_id: this.props.companyId,
                  //       order_id: d.id,
                  //       container_id: c.id_container,
                  //       fleet_equipment: equipmentList[i].id || 0,
                  //     })
                  //   })
                  // });

                  showSimpleFlashNotification('Se realizó el cambio con éxito', null)

                  this.setState({
                    isLoading: false,
                    showAssignDialog: false,
                    selectedAssembly: 0,
                    currentTrip: undefined,
                    hasAutoStart: true,
                    assign: null,
                  });
              },
              onError: (e) => {
                let errors = e.response?.data?.errors || [];

                this.setState({
                  assign: null,
                  isLoading: false,
                  showAssignDialog: false,
                  selectedAssembly: 0,
                  currentTrip: undefined,
                  hasAutoStart: true,
                  errorMessage: errors.map( e => e ).join(', ')
                });
              }
            }
          );
        // }
        break;
      default:
        this.setState({ [name]: value });
    }
  };

  buildTripToAssign = () => {
    if (this.state.assign === null) return null;

    return({
      id: this.state.assign.trip_id,
      hasProvider: this.state.assign.fleet_provider !== null,
      isCompanyVerified: true,
      companyName: '',
      tripNumber: this.state.assign.signature,
      tickets: this.state.assign.orders_count,
      status: this.state.assign.status?.description || '',
      class: null,
      assemble: null,
      tc: '',
      mainFacility: (this.state.assign.orders || []).map( item => item.to_facility?.id || 0),
      tags: (this.state.assign.tags || []).map( item => item.id || 0),
      is_unhooked: false,
      details: (this.state.assign.orders || []).map( item => ({
        id: item.order_id,
        ticket: item.code,
        origin: {
          facilityId: item.from_facility.id,
          editable: true,
          logo: '',
          name: item.from_facility.name,
          date: '',
          location: '',
          isCompanyVerified: true
        },
        destination: {
          facilityId: item.to_facility.id,
          editable: true,
          logo: '',
          name: item.to_facility.name,
          date: '',
          location: '',
          isCompanyVerified: true
        },
      }))
    });
  }

  render() {
  
    return (
      <View className="orders-control-view">

        {
          (this.props.isLoading) && 
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "#00000080",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
              backdropFilter: "blur(3px)"
            }}
          >
            <div style={{display: "flex", alignItems: "center"}}>
              <Loader width="100px" height="100px"/>
              <div style={{color: "#fff", fontSize: "36px"}}>
                Cargando
              </div>
            </div>
            <div style={{color: "#fff", fontSize: "30px"}}>
              Si desea cancelar la consulta, presione ESC
            </div>
          </div>
        }

        <ViewTitle>
          <span>{'Control de Embarques'}</span>
        </ViewTitle>

        <div className="switches-container">

          <div/>

          <OptionSelectorSwitch
            value={this.state.tripType}
            name="tripType"
            onChange={this.handleTabChange}
            items={TRIPTYPES}
          />

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              marginBottom: 30
            }}
          > 
            <FilterBarCompact
              limit={350}
              searchStr={this.state.emails}
              searchAction={this.handleEmailInput}
              multiText={true}
              searchPlaceholder={"Buscar Viaje"}
              clearMultiText={() => {
                this.setState({ emails: [], searchStr: "" });
              }}
              filterAction={() => {
                if (this.state.buttonFilterName === "Aplicar") {
                  this.setState(
                    {
                      offset: 1,
                      buttonFilterName: "Restablecer"
                    },
                    () => { this.loadItems(); }
                  );
                } else {

                  this.setState({
                    offset: 1,
                    emails: [], 
                    searchStr: "",
                    filter: {
                      baseTags: [],
                      vehicle: [],
                      transportClass: [],
                      tripStatus: [],
                      orderStatus: [],
                      fleetProviders: [],
                      fromFacilities: [],
                      toFacilities: [],
                      fromToFacilities: [],
                      appointment: [],
                      appointmentType: []
                    },
                    buttonFilterName: "Aplicar"
                  }, () => { this.loadItems(); })

                }
              }}
              buttonFilterName={this.state.buttonFilterName}
              content={this.filterContent()}
              onChange={(e) => {
                this.state.filter = {
                  ...this.state.filter,
                  [e.target.name]: e.target.value,
                };

                this.setState({
                  offset: 1,
                  buttonFilterName: "Aplicar"
                });
              }}
              selectedItems={this.state.filter}
            />
          </div>
        
        </div>

        <div className="content">

          <ResetButtonContainer>
            <div 
              className="reset-button"
              onClick={() => {
                
                this.setState({
                  tripFilter: {},
                  seed: Math.random()
                });

                this.props.updateTripFilterConfig({
                  company_id: this.props.companyId,
                  trip_tr_filter: {}
                });

              }}
            >{'Reestablecer acomodo de columnas'}</div>
          </ResetButtonContainer>

          {
            this.getHeaderInfoSelection()
          }

          <TripTrTableView
            key={this.state.seed}
            rowData={this.props.tripsData || []}
            handleChange={this.handleTripGridChange}
            allSelected={this.state.isAllTripsSelected}
            configuration={this.state.tripFilter || {}}
            isLoading={this.props.isUpdatingFiltersLoading}
            setNewFilter={(new_filter) => {
              this.setState({
                tripFilter: new_filter
              });

              this.props.updateTripFilterConfig({
                company_id: this.props.companyId,
                trip_tr_filter: new_filter
              });
            }}
          />

          <div style={{}}>
            <PaginatorControlled
              itemCount={this.getCount()}
              onChange={(e) => {
                this.setState({ [e.target.name]: e.target.value }, () => {
                  if (this.state.getOrdersCalled === true) {
                    this.loadItems();
                  }
                });
              }}
              limit={this.state.limit}
              offset={this.state.offset}
            />
          </div>

          {
            (this.state.tripsSelected.length > 0) &&
            <CatalogSelectionFooter
              key={`catalog-footer`}
              hideSelectAll={true}
              show={this.state.tripsSelected.length > 0}
              selectedElements={this.state.tripsSelected.length}
              selectAll={() => {
                this.setState({
                  isAllTripsSelected: true,
                  seed: Math.random()
                });
              }}
              actions={[
                {
                  description: "Editar Base",
                  f: () => { }
                },
                {
                  description: "Finalizar Sin Datos",
                  f: () => { }
                },
                {
                  description: "Cerrar",
                  f: () => {
                    this.setState({seed: Math.random(), tripsSelected: [], isAllTripsSelected: false});
                  },
                }
              ]}
            />
          }

          {
            this.state.showConfirmDialog &&
            <BaseDialog
              closeAction={() => {this.setState({showConfirmDialog: false, hasAutoStart: true, currentTrip: undefined, confirmReservation: null})}}
              acceptAction={this.acceptTripAction}
              open={this.state.showConfirmDialog}
              title={"Confirmar reservación"}
              contentObject={this.getModalContent()}
              showCancel={true}
              cancelText="Cerrar"
              cancelButtonType="primary outline dark"
              acceptText="Confirmar"
              isAcceptLoading={this.props.isConfirmingLoading}
              // disabledAccept={!this.props.selectedAssembly}
              acceptButtonType="primary"
              style={{ content: { width: "480px", marginLeft: "-240px" } }}
            ></BaseDialog>
          }

          {
            this.state.errorMessage !== null &&
            <GenericDialog
              open={this.state.errorMessage !== null}
              title={'Error'}
              message={this.state.errorMessage}
              acceptAction={() => this.setState({errorMessage: null})}
              closeAction={() => this.setState({errorMessage: null})}
            />
          }

          { (this.state.showAssignDialog) && (
            <AssembleShipmentAssignDialog
              assemblies={ (this.props.tripBookingAvailabilityLoading === false) ? this.props.tripBookingAvailability : []}
              show={this.state.showAssignDialog}
              manager={this.manageAssignModal}
              logo={this.props.companyData.logo}
              trip={this.buildTripToAssign()}
              selectedAssembly={this.state.selectedAssembly}
              hasAutoStart={this.state.hasAutoStart}
              handleAutoStart={this.handleAutoStart}
              isLoading={this.state.isLoading}
            />
          )}

        </div>


      </View>
    );
  }

}

const mapStateToProps = (state) => {
  const companyId = state.globalCatalog.session.company.id;
  const isTripsCatalogLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.TRIPS.CATALOG2TR']?.status?.isFetching || false;
  const tripsData = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.TRIPS.CATALOG2TR")["results"] || []; 
  const tripsCount = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.TRIPS.CATALOG2TR")["count"] || 0;

  const companyTags = getEntityItems(state, "COMPANIES.TAGS");
  const tripStatuses = getEntityItems(state, "COMPANIES.CATALOGS.TRIPSTATUS").map((f) => ({description: f.description, id: f.id || 0}));
  const orderStatus = getEntityItems(state,"COMPANIES.CATALOGS.ORDERSTATUS").map((f) => ({description: f.description, id: f.id || 0 }));
  const filterInfo = getEntityItems(state, "COMPANIES.SHIPMENTS.LT.FILTERS");
  const isConfirmingLoading = state.api["COMPANIES.TRIPS"]?.status?.isFetching || false;

  let tempTransportClass = [];
  let transportClass = getEntityItems(state,"COMPANIES.SHIPMENTS.LT.FILTERS");

  (transportClass || []).forEach(e => {
    (e.transport_classes_tags || []).forEach(t => {
      if(tempTransportClass.find(toFind => toFind.description === `${e.orbi_id} - ${t.tags.title}`) === undefined){
        const classes = (e.transport_classes_tags || []).filter(tag => tag.tags.title === t.tags.title)
        
        let selectedClasses = []
        classes.forEach(s => {
          (e.transport_classes || []).forEach(classe => {
            if(classe.id === s.transport_class){
              selectedClasses.push(classe)
            }
          })
        })

        tempTransportClass.push(
          { 
            description: `${e.orbi_id} - ${t.tags.title}`,
            id: e.id,
            items: selectedClasses.map((tc) => ({
              id: tc.id,
              description: tc.code,
            })),
          }
        )
      }
    })
  });

  transportClass = tempTransportClass;

  const companyProviders = getEntityItems(state, "COMPANIES.NETWORK").map(
    (f) => ({
      description: f.fleet_provider.orbi_id || f.fleet_provider.corporation_name,
      id: f.fleet_provider.fleet_provider_id || 0,
    })
  );

  const isVehiclesLoading = state?.api['COMPANIES.CATALOGS.VEHICLE']?.status?.isFetching || false;

  const tripBalance = getEntityItems(state, "COMPANIES.TRIPS.BALANCE");
  const isTripBalanceLoading = state.api["COMPANIES.TRIPS.BALANCE"]?.status?.isFetching || false;
  const tripBookingAvailabilityLoading = state.api["TripBookingAvailability"]?.status?.isFetching;

  const tripBookingAvailability = getEntityItems(
      state,
      "TripBookingAvailability"
    ).map(Utils.mapTripBookingAvailability);
  const companyData = state.globalCatalog.session.company;

  return {
    tripBookingAvailability,
    tripBookingAvailabilityLoading,
    isConfirmingLoading,
    filterInfo,
    companyProviders,
    orderStatus,
    tripStatuses,
    companyId,
    companyTags,
    transportClass,
    isLoading: isTripsCatalogLoading || isVehiclesLoading,
    isUpdatingFiltersLoading: false,
    tripsData,
    tripsCount,
    tripBalance,
    isTripBalanceLoading,
    isTripsCatalogLoading,
    companyData
  };
}

const mapDispatchToProps = (dispatch) => {
  dispatch(readEntities("COMPANIES.CATALOGS.ORDERSTATUS"));
  dispatch(readEntities("COMPANIES.CATALOGS.TRIPSTATUS"));

  return {
    cancelMultipleRequests: () => dispatch(cancelMultipleRequests()),
    loadCompanyTags: (params, opts) => dispatch(readEntities("COMPANIES.TAGS", params, opts)),
    listVehicles: (params, opts) => dispatch(readCatalog("COMPANIES.CATALOGS.VEHICLE", params, opts)),
    loadTransportClass: (params, opt) => dispatch(readEntities("COMPANIES.SHIPMENTS.LT.FILTERS", params, opt)),
    loadCompanyProviders: (params, opts) => dispatch(readEntities("COMPANIES.NETWORK", params, opts)),
    loadFilters: (params, opt) => dispatch(readEntities("COMPANIES.SHIPMENTS.LT.FILTERS", params, opt)),
    loadTrips: (params, opt) => dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.TRIPS.CATALOG2TR", params, opt)),
    loadTripFilterConfig: (params, opt) => dispatch(readEntity("COMPANIES.TRIPSCONTROL.FILTERCONFIGURATION", params, opt)),
    updateTripFilterConfig: (params, opts) => dispatch(partialEntity("COMPANIES.TRIPSCONTROL.FILTERCONFIGURATION.UPDATE", params, opts)),
    updateTrip: (params, opts) => dispatch(partialEntity("COMPANIES.TRIPS", params, opts)),
    getTripBalance: (params, opts) => dispatch(readEntity("COMPANIES.TRIPS.BALANCE", params, opts)),
    loadTrip: (params, opts) => dispatch(readEntity("COMPANIES.TRIPS", params, opts))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsTrControlView);

const ResetButtonContainer = styled.div`
  width: 100%;
  display: flex;
  height: 25px;
  justify-content: right;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;

  & .reset-button {
    cursor: pointer;
    font-size: 16px;
    text-decoration: underline;
    color: white;

    &:hover {
      font-size: 18px;
    }
  }
`;